import { render } from "./HistoryComponent.vue?vue&type=template&id=401534cc"
import script from "./HistoryComponent.vue?vue&type=script&defer=true&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&defer=true&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__